import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableTHeadRow as ClbTableTHeadRow_ } from '@celebration/design-system/dist/lib/table-thead-row';
const events = {
    onClbSelectTheadRow: ClbTableTHeadRow_.events
        .onClbSelectTheadRow,
};
export const ClbTableTHeadRow = createComponent({
    tagName: ClbTableTHeadRow_.tagName,
    elementClass: ClbTableTHeadRow_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map